import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
    useRoutes,
    useAssuranceApi,
    Routes,
    IResumeOffre,
    IAssureResume,
    hasSoumissionAssurance,
    ParcoursAssurance,
    ActionsAssurance
} from '../../hooks';
import {
    hideLoading,
    sendEvent,
    EVENT_CATEGORIES,
    EVENT_ACTIONS,
    EVENT_LABELS
} from '../../features';
import { ResumeAssurance } from './ResumeAssurance';
import { Headings } from '../../styles';
import { HeadingProvider } from '../../context';

export interface IResumeAssuranceConnectedProps {
    idDemande: number;
    resumeOffre: IResumeOffre;
    isAssuranceAdmissible: boolean;
    isEditButtonDisplayed: boolean;
    isNoAssuranceDisplayed: boolean;
    isModalProtectionVisible?: boolean; // dans le cas martine choixCoEmprunteur
    assures: Array<IAssureResume>;
    parcoursAssurance: ParcoursAssurance;
}

export const ResumeAssuranceConnected: React.FC<
    IResumeAssuranceConnectedProps
> = ({
    idDemande,
    resumeOffre,
    isEditButtonDisplayed,
    isAssuranceAdmissible,
    isNoAssuranceDisplayed,
    isModalProtectionVisible,
    assures,
    parcoursAssurance
}) => {
    const dispatch = useDispatch();
    const { goToRoute } = useRoutes();
    const [actionsAssurancePourRedirect, setActionsAssurancePourRedirect] =
        useState(null);

    // Apis
    const assuranceApiMutation = useAssuranceApi();

    const headingMapping = {
        h3: Headings.h4
    };

    const handleEditAssurance = (action: ActionsAssurance) => {
        dispatch(
            sendEvent({
                category: EVENT_CATEGORIES.RHN,
                action: EVENT_ACTIONS.CLIC,
                label: EVENT_LABELS.MODIFIER + 'assurance prêt'
            })
        );

        if (hasSoumissionAssurance(resumeOffre?.assurance?.codeAssurance)) {
            assuranceApiMutation.mutateAsync(idDemande);
            setActionsAssurancePourRedirect(action);
        } else {
            goToRoute(Routes.EVEIL_ASSURANCE);
        }
    };

    // Retour de l'appel basculer vers assurance -> redirectUrl
    useEffect(() => {
        if (assuranceApiMutation.isSuccess) {
            if (assuranceApiMutation.data?.redirectUrl) {
                const assuranceRedirectUrl = String(
                    assuranceApiMutation.data?.redirectUrl
                ).concat('?action=' + actionsAssurancePourRedirect);

                window.location.href = assuranceRedirectUrl;
            } else {
                dispatch(hideLoading());
            }
        }
    }, [assuranceApiMutation.isSuccess]);

    return (
        <HeadingProvider value={headingMapping}>
            <ResumeAssurance
                resumeOffre={resumeOffre}
                assures={assures}
                isAssuranceAdmissible={isAssuranceAdmissible}
                isEditButtonDisplayed={isEditButtonDisplayed}
                isNoAssuranceDisplayed={isNoAssuranceDisplayed}
                isModalProtectionVisible={isModalProtectionVisible}
                parcoursAssurance={parcoursAssurance}
                onEditAssurance={handleEditAssurance}
            />
        </HeadingProvider>
    );
};
